module.exports = __webpack_public_path__ + "img/about-category-bg@tl.ec56a32.svg";


//////////////////
// WEBPACK FOOTER
// ./static/img/about-category-bg@tl.svg
// module id = euzV
// module chunks = 2